import React from "react";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ExpenseCardWarningText.module.css";

interface Props {
  text: string;
}

const ExpenseCardWarningText: React.FC<Props> = ({ text }) => {
  return (
    <div className={styles.flexRow}>
      <Text className={styles.warningText} variant="body" color={"text"}>
        {text}
      </Text>
      <InfoOutlinedIcon className={styles.icon} />
    </div>
  );
};

export default ExpenseCardWarningText;
